import LabelCoordinator from 'shared/modules/labelCoordinator';

const getDisplayNameByDivisionName = (divisionName) =>
  LabelCoordinator.getDataKeyDisplayName('cueDisplayCoordinator', divisionName);

export default getDisplayNameByDivisionName;
